// getProposalReport
const INITIAL_STATE = {
data: {},
errors: {}
}

const getProposalReport = (state = INITIAL_STATE, action) => {
switch (action.type) {
case 'GET_RESIDENTIAL_LEAD_REPORT_SUCCESSFULLY':
	return { ...state, ...INITIAL_STATE, data: action.data }
case 'GET_RESIDENTIAL_LEAD_REPORT_FAILED':
	return { ...state, ...INITIAL_STATE, errors: action.data }
default:
	return { ...state }
}
};
		
export default getProposalReport;